(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "renderBoard",
            value: function renderBoard() {
                var cells = document.querySelectorAll(".field-cell");
                var flattenedBoard = this.board.flat();
                cells.forEach(function(cell, index) {
                    var value = flattenedBoard[index];
                    cell.textContent = value === 0 ? "" : value;
                    if (value > 0) cell.classList.add("field-cell--".concat(value));
                    else cell.classList = "field-cell";
                });
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var row = 0; row < this.board.length; row++)for(var col = 0; col < this.board[row].length; col++){
                    if (this.board[row][col] === 0) return true;
                    if (col > 0 && this.board[row][col] === this.board[row][col - 1]) return true;
                    if (col < this.board[row].length - 1 && this.board[row][col] === this.board[row][col + 1]) return true;
                    if (row > 0 && this.board[row][col] === this.board[row - 1][col]) return true;
                    if (row < this.board.length - 1 && this.board[row][col] === this.board[row + 1][col]) return true;
                }
                this.lose();
                return false;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var compacted = _this.board[row].filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < compacted.length - 1; i++)if (compacted[i] === compacted[i + 1]) {
                        compacted[i] *= 2;
                        _this.score += compacted[i];
                        compacted[i + 1] = 0;
                    }
                    var newRow = compacted.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    _this.board[row] = newRow;
                    if (newRow.includes(2048)) {
                        _this.status = "win";
                        _this.displayWinMessage();
                        return {
                            v: void void 0
                        };
                    }
                };
                if (!this.canMove()) return;
                var copyBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var row = 0; row < this.board.length; row++){
                    var _ret = _loop(row);
                    if ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(_ret) === "object") return _ret.v;
                }
                if (!this.boardsAreEqual(copyBoard, this.board)) this.addRandomTile();
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var compacted = _this.board[row].filter(function(cell) {
                        return cell !== 0;
                    }).reverse();
                    for(var i = 0; i < compacted.length - 1; i++)if (compacted[i] === compacted[i + 1]) {
                        compacted[i] *= 2;
                        _this.score += compacted[i];
                        compacted[i + 1] = 0;
                    }
                    var newRow = compacted.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    _this.board[row] = newRow.reverse();
                    if (newRow.includes(2048)) {
                        _this.status = "win";
                        _this.displayWinMessage();
                        return {
                            v: void void 0
                        };
                    }
                };
                if (!this.canMove()) return;
                var copyBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var row = 0; row < this.board.length; row++){
                    var _ret = _loop(row);
                    if ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(_ret) === "object") return _ret.v;
                }
                if (!this.boardsAreEqual(copyBoard, this.board)) this.addRandomTile();
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 0; row < _this.board.length; row++)column.push(_this.board[row][col]);
                    var compacted = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < compacted.length - 1; i++)if (compacted[i] === compacted[i + 1]) {
                        compacted[i] *= 2;
                        _this.score += compacted[i];
                        compacted[i + 1] = 0;
                    }
                    var newColumn = compacted.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newColumn.length < 4)newColumn.push(0);
                    for(var row1 = 0; row1 < _this.board.length; row1++)_this.board[row1][col] = newColumn[row1];
                    if (newColumn.includes(2048)) {
                        _this.status = "win";
                        _this.displayWinMessage();
                        return {
                            v: void void 0
                        };
                    }
                };
                if (!this.canMove()) return;
                var copyBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var col = 0; col < this.board[0].length; col++){
                    var _ret = _loop(col);
                    if ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(_ret) === "object") return _ret.v;
                }
                if (!this.boardsAreEqual(copyBoard, this.board)) this.addRandomTile();
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 0; row < _this.board.length; row++)column.push(_this.board[row][col]);
                    column.reverse();
                    var compacted = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < compacted.length - 1; i++)if (compacted[i] === compacted[i + 1]) {
                        compacted[i] *= 2;
                        _this.score += compacted[i];
                        compacted[i + 1] = 0;
                    }
                    var newColumn = compacted.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newColumn.length < 4)newColumn.push(0);
                    newColumn.reverse();
                    for(var row1 = 0; row1 < _this.board.length; row1++)_this.board[row1][col] = newColumn[row1];
                    if (newColumn.includes(2048)) {
                        _this.status = "win";
                        _this.displayWinMessage();
                        return {
                            v: void void 0
                        };
                    }
                };
                if (!this.canMove()) return;
                var copyBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var col = 0; col < this.board[0].length; col++){
                    var _ret = _loop(col);
                    if ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(_ret) === "object") return _ret.v;
                }
                if (!this.boardsAreEqual(copyBoard, this.board)) this.addRandomTile();
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "boardsAreEqual",
            value: function boardsAreEqual(board1, board2) {
                if (board1.length !== board2.length) return false;
                for(var row = 0; row < board1.length; row++)for(var col = 0; col < board1[row].length; col++){
                    if (board1[row][col] !== board2[row][col]) return false;
                }
                return true;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "updateScore",
            value: function updateScore() {
                var scoreElement = document.querySelector(".game-score");
                scoreElement.textContent = this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return {
                    board: this.board,
                    score: this.score,
                    status: this.status
                };
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "resetBoard",
            value: function resetBoard() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCell = [];
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (this.board[row][col] === 0) emptyCell.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyCell.length > 0) {
                    var randomIndex = Math.floor(Math.random() * emptyCell.length);
                    var _emptyCell_randomIndex = emptyCell[randomIndex], row1 = _emptyCell_randomIndex.row, col1 = _emptyCell_randomIndex.col;
                    var newTile = Math.random() < 0.9 ? 2 : 4;
                    this.board[row1][col1] = newTile;
                    this.score += newTile;
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.status = "idle";
                this.resetBoard();
                this.score = 0;
                this.updateScore();
                this.renderBoard();
            }
        },
        {
            key: "lose",
            value: function lose() {
                this.status = "lose";
                document.querySelector(".message-restart").classList.add("hidden");
                document.querySelector(".message-start").classList.add("hidden");
                document.querySelector(".message-lose").classList.remove("hidden");
            }
        },
        {
            key: "displayWinMessage",
            value: function displayWinMessage() {
                var winMessage = document.querySelector(".message-win");
                document.querySelector(".message-restart").classList.add("hidden");
                document.querySelector(".message-start").classList.add("hidden");
                winMessage.classList.remove("hidden");
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;
window.Game = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
document.addEventListener("keydown", function(even) {
    switch(even.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
});
var $197cd56b15c33885$var$buttonStart = document.querySelector(".button.start");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageRestart = document.querySelector(".message-restart");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    if ($197cd56b15c33885$var$buttonStart.classList.contains("start")) {
        $197cd56b15c33885$var$buttonStart.textContent = "Restart";
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$buttonStart.classList.remove("start");
        $197cd56b15c33885$var$buttonStart.classList.add("restart");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageRestart.classList.remove("hidden");
    } else {
        $197cd56b15c33885$var$buttonStart.textContent = "Start";
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$buttonStart.classList.remove("restart");
        $197cd56b15c33885$var$buttonStart.classList.add("start");
        $197cd56b15c33885$var$messageRestart.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    }
});

})();
//# sourceMappingURL=index.286e4b33.js.map
